<template>
  <div>
    <LMap
      :zoom="zoom"
      :center="center"
      :bounds="bounds"
      ref="map"
      style="height: 500px; z-index:0;"
      class="rounded-custom"
    >
      <LMarker
        v-for="(eventMarker, index) of eventMarkerList"
        :lat-lng="eventMarker.latLng"
        :key="index"
      ></LMarker>
    </LMap>
  </div>
</template>

<script>
import { latLngBounds, latLng } from "leaflet";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
export default {
  components: { LMap, LTileLayer, LMarker },
  props: ["eventList"],
  data: () => ({
    zoom: 10,
    center: { lat: -33.0055093, lng: -71.6002957 },
    bounds: null,
    /*     url:
      "https://api.maptiler.com/maps/hybrid/?key=4vPvto1PiukVFq6PjxW3#0.0/0.00000/0.00000", //"http://{s}.tile.osm.org/{z}/{x}/{y}.png", */
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
  }),
  computed: {
    eventMarkerList() {
      return (this.eventList || [])
        .filter(event => event.coordinates)
        .map(event => ({
          id: event.id,
          latLng: event.coordinates.reverse()
        }));
    }
  },
  watch: {
    eventMarkerList() {
      if (this.eventMarkerList.length) {
        this.bounds = L.latLngBounds(
          this.eventMarkerList.map(({ latLng }) => L.latLng(latLng))
        );
      }
    }
  },
  mounted() {
    this.$refs.map.mapObject._onResize();

    var bingLayer = L.tileLayer
      .bing({
        bingMapsKey:
          "AqZzddAfYuAhbM8Ez9sYiA81Of7Y9xM2idIEFhDH7nc_897g4AMq4TpnKvdmP0To",
        imagerySet: "AerialWithLabels"
      })
      .addTo(this.$refs.map.mapObject);
  }
};
</script>

<style></style>
